import type { SiteConfig } from '@/mocks/site';

export const siteConfig = {
  name: '91看片网',
  tagline: '发现好片，热爱光影',
  description: '91看片网致力于为影视爱好者提供最新最全的影视资讯、深度影评和优质内容推荐。涵盖电影、电视剧、动漫、综艺等全方位影视内容，是您观影追剧的首选平台。',
  url: 'https://moviewise91.github.io',
  logo: '',
  email: 'contact@91kanpian.com',
  phone: '400-888-9999',
  address: '北京市朝阳区光华路9号',
  social: {
    weibo: 'https://weibo.com/91kanpian',
    wechat: '91kanpian',
    douyin: '@91看片网',
  },
  founded: '2018',
  stats: {
    articles: 232,
    categories: 6,
    users: '50万+',
    views: '2000万+',
  },
};